import { render, staticRenderFns } from "./PowerTelegramView.vue?vue&type=template&id=a1aaba50&scoped=true"
import script from "./PowerTelegramView.vue?vue&type=script&lang=js"
export * from "./PowerTelegramView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1aaba50",
  null
  
)

export default component.exports